import { AT_PERFORMANCE_ALLOWED_SET, ICookieDialogPerformanceAllowedSetAction } from './types';

export const performanceAllowedSet = (
    isPerformanceAllowed: boolean
): ICookieDialogPerformanceAllowedSetAction => ({
    type: AT_PERFORMANCE_ALLOWED_SET,
    isPerformanceAllowed
});
